import BACKUP_DARK from 'assets/overview/multi-dark.png'
import BACKUP_LIGHT from 'assets/overview/multi.png'
import INTEGRATE_DARK from 'assets/overview/integrated-dark.png'
import INTEGRATE_LIGHT from 'assets/overview/integrated.png'
import TRANSPARENT_DARK from 'assets/overview/transparent-dark.png'
import TRANSPARENT_LIGHT from 'assets/overview/transparent.png'

export const getProductDetails = (isDarkMode: boolean) => [
  {
    image: isDarkMode ? BACKUP_DARK : BACKUP_LIGHT,
    description: 'Multi-chain exposure across EVM and non-EVM ecosystems',
  },
  {
    image: isDarkMode ? TRANSPARENT_DARK : TRANSPARENT_LIGHT,
    description:
      '100% backed by the underlying assets with transparent and trustless access to your funds ',
  },
  {
    image: isDarkMode ? INTEGRATE_DARK : INTEGRATE_LIGHT,
    description: 'Integrated and accessible throughout the DeFi ecosystem',
  },
]
